import { render } from "./photoView.vue?vue&type=template&id=51cb714b&scoped=true"
import script from "./photoView.vue?vue&type=script&lang=js"
export * from "./photoView.vue?vue&type=script&lang=js"

import "./photoView.vue?vue&type=style&index=0&id=51cb714b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51cb714b"]])

export default __exports__